<template>
  <nav class="manual-nav">
    <div class="mb-6">
      <h2 class="text-xs font-semibold text-gray-400 uppercase tracking-wider mb-3">
        Manual de Administración
      </h2>
    </div>

    <ul class="space-y-1">
      <li v-for="item in navItems" :key="item.route">
        <router-link
          :to="{ name: item.route }"
          class="nav-link flex items-center px-3 py-2.5 rounded-lg text-sm font-medium transition-all"
          :class="[
            isActive(item.route)
              ? 'bg-primary-100 text-primary-700'
              : 'text-gray-600 hover:bg-gray-100 hover:text-gray-900'
          ]"
        >
          <component :is="item.icon" class="w-5 h-5 mr-3 flex-shrink-0" />
          <span>{{ item.label }}</span>
        </router-link>
      </li>
    </ul>

    <!-- Support Section -->
    <div class="mt-8 pt-6 border-t border-gray-200">
      <h3 class="text-xs font-semibold text-gray-400 uppercase tracking-wider mb-3">
        Soporte
      </h3>
      <a
        href="https://wa.me/528116691329"
        target="_blank"
        class="flex items-center px-3 py-2.5 rounded-lg text-sm font-medium text-gray-600 hover:bg-green-50 hover:text-green-700 transition-all"
      >
        <whatsapp-icon class="w-5 h-5 mr-3" />
        <span>WhatsApp</span>
      </a>
      <a
        href="mailto:soporte@trunimal.com"
        class="flex items-center px-3 py-2.5 rounded-lg text-sm font-medium text-gray-600 hover:bg-gray-100 hover:text-gray-900 transition-all"
      >
        <email-icon class="w-5 h-5 mr-3" />
        <span>Correo electrónico</span>
      </a>
    </div>
  </nav>
</template>

<script>
import HomeIcon from "@/icons/HomeIcon.vue";
import ClientsIcon from "@/icons/ClientsIcon.vue";
import PetsIcon from "@/icons/PetsIcon.vue";
import QuoteRequestsIcon from "@/icons/QuoteRequestsIcon.vue";
import AppointmentsIcon from "@/icons/AppointmentsIcon.vue";
import QuotesIcon from "@/icons/QuotesIcon.vue";
import OrdersIcon from "@/icons/OrdersIcon.vue";
import BranchIcon from "@/icons/BranchIcon.vue";
import DietCategoryIcon from "@/icons/DietCategoryIcon.vue";
import UsersIcon from "@/icons/UsersIcon.vue";
import CartIcon from "@/icons/CartIcon.vue";
import AccountingIcon from "@/icons/AccountingIcon.vue";
import ReportsIcon from "@/icons/ReportsIcon.vue";
import WhatsappIcon from "@/icons/WhatsappIcon.vue";
import EmailIcon from "@/icons/EmailIcon.vue";

export default {
  name: "ManualNav",

  components: {
    HomeIcon,
    ClientsIcon,
    PetsIcon,
    QuoteRequestsIcon,
    AppointmentsIcon,
    QuotesIcon,
    OrdersIcon,
    BranchIcon,
    DietCategoryIcon,
    UsersIcon,
    CartIcon,
    AccountingIcon,
    ReportsIcon,
    WhatsappIcon,
    EmailIcon,
  },

  data() {
    return {
      navItems: [
        {
          route: "manualGettingStarted",
          label: "Primeros Pasos",
          icon: "HomeIcon",
        },
        {
          route: "manualClients",
          label: "Clientes",
          icon: "ClientsIcon",
        },
        {
          route: "manualPets",
          label: "Mascotas",
          icon: "PetsIcon",
        },
        {
          route: "manualQuoteRequests",
          label: "Solicitudes",
          icon: "QuoteRequestsIcon",
        },
        {
          route: "manualAppointmentRequests",
          label: "Citas con Especialista",
          icon: "AppointmentsIcon",
        },
        {
          route: "manualPlans",
          label: "Planes",
          icon: "QuotesIcon",
        },
        {
          route: "manualOrders",
          label: "Órdenes",
          icon: "OrdersIcon",
        },
        {
          route: "manualFranchises",
          label: "Franquicias",
          icon: "BranchIcon",
        },
        {
          route: "manualDietManagement",
          label: "Alimentos",
          icon: "DietCategoryIcon",
        },
        {
          route: "manualUsers",
          label: "Usuarios",
          icon: "UsersIcon",
        },
        {
          route: "manualStore",
          label: "Tienda",
          icon: "CartIcon",
        },
        {
          route: "manualAccounting",
          label: "Contabilidad",
          icon: "AccountingIcon",
        },
        {
          route: "manualReports",
          label: "Reportes",
          icon: "ReportsIcon",
        },
      ],
    };
  },

  methods: {
    isActive(route) {
      return this.$route.name === route;
    },
  },
};
</script>

<style scoped>
.manual-nav {
  @apply sticky top-0;
}

.nav-link {
  @apply relative;
}

.nav-link.router-link-active::before {
  content: "";
  @apply absolute left-0 top-1/2 -translate-y-1/2 w-1 h-6 bg-primary-500 rounded-r;
}
</style>
